import { HttpErrorResponse } from '@angular/common/http';

export function authRetryAfterSeconds(error: unknown, fallback = 60): number | null {
  if (!(error instanceof HttpErrorResponse) || error.status !== 429) return null;
  const raw = error.headers.get('Retry-After');
  const seconds = Number(raw);
  if (Number.isFinite(seconds) && seconds > 0) return Math.ceil(seconds);
  const date = raw ? Date.parse(raw) : Number.NaN;
  return Number.isFinite(date) ? Math.max(1, Math.ceil((date - Date.now()) / 1000)) : fallback;
}
